import { Select, MenuItem } from '@mui/material';
// import { useMapContext } from "../Map/MapContext";
import { useMapContext } from './Map/MapContext';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

const StormDateDropDown = () => {
    const {stormOptions, selectedStormOption, setSelectedStormOption,} = useMapContext();

    const handleDropdownChange = (event) => {
        setSelectedStormOption(event.target.value);
        console.log(event.target.value);
    }

    const formatStormDate = (stormOption) => {
        const stormDates = {
            'mar27': "2\" 30-hour storm (2020)",
            'May19': "2\" 6-hour storm (2019)",
            'Jul18': "1\" 3-hour storm (2018)",
            'Aug16': "3\" 10-hour storm (2016)"
        };
        return stormDates[stormOption] || stormOption;
    }

    return (
        <FormControl
            variant="standard"
            sx={{
            position: 'absolute',
            top: 75,
            left: 15,
            zIndex: 1000,
            borderRadius: '5px',
            width: 'auto',
            height: '35px',
            // backgroundColor: '#212121',
            }}
        >
            <InputLabel id="color-scheme-label">Simulated Storm</InputLabel>
            <Select
                value={selectedStormOption}
                onChange={handleDropdownChange}
            >
                {stormOptions.map((stormDate) => (
                    <MenuItem key={stormDate} value={stormDate}>
                        {formatStormDate(stormDate)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default StormDateDropDown;
